import * as d3 from 'd3';
import * as _ from 'lodash';

import { QualityId as ErrorStatus, IValueViewModel, GroupNameDto } from '../../models';


export interface IQualityAnalysisTableHelper {
    mapCalculatedDataToRows(data: { [index: string]: { [index: number]: number } }, identifiers: IValueViewModel[]): any[];
    mapValidatedDataToRows(data: { [index: string]: { [index: number]: number } }, identifiers: IValueViewModel[]): any[];
    getIdentifiers(selectedGroup: GroupNameDto, viewModels: IValueViewModel[], includeChildren: boolean): IValueViewModel[];
}

export class QualityAnalysisTableHelper implements IQualityAnalysisTableHelper {
    static id = 'qualityAnalysisTableHelper';

    private _format = d3.format('.0%');

    static $inject = [];

    mapCalculatedDataToRows(data: { [index: string]: { [index: number]: number } },
        identifiers: IValueViewModel[]) {
        const keys = Object.keys(data);
        const rows = _.chain(identifiers)
            .filter(i => keys.indexOf(i.guid) >= 0)
            .map((d: IValueViewModel) => {
                const missing = data[d.guid][ErrorStatus.Missing];
                const invalid = data[d.guid][ErrorStatus.Invalid];
                const suspicious = data[d.guid][ErrorStatus.Suspicious];
                const outOfRange = data[d.guid][ErrorStatus.OutOfRange];
                return [
                    {
                        text: d.name,
                        type: 0,
                        classed: '',
                        item: d
                    },
                    {
                        text: d.groupUniqueName,
                        type: 1,
                        item: d.groupList[0]
                    },
                    { text: d.shortComment, type: 2 },
                    { text: d.unitName, type: 2 },
                    this.mapNumber(missing),
                    this.mapNumber(invalid),
                    this.mapNumber(suspicious),
                    this.mapNumber(outOfRange)
                ];
            })
            .sortBy(d => (d[4] as any).value)
            .reverse()
            .value();
        return rows;
    }

    mapValidatedDataToRows(
        data: { [index: string]: { [index: number]: number } },
        identifiers: IValueViewModel[]
    ) {
        const keys = Object.keys(data);
        const rows = _.chain(identifiers)
            .filter(i => keys.indexOf(i.guid) >= 0)
            .map((d: IValueViewModel) => {
                const missing = data[d.guid][ErrorStatus.Missing];
                const corrected = data[d.guid][ErrorStatus.Corrected];
                return [
                    {
                        text: d.name,
                        type: 0,
                        classed: '',
                        item: d
                    },
                    {
                        text: !!d.tagName ? d.tagName : '',
                        type: !!d.tagName ? 3 : 2,
                        item: d.tagName ? d.selectableIdentifiers[0] : null
                    },
                    {
                        text: d.groupUniqueName,
                        type: 1,
                        item: d.groupList[0]
                    },
                    { text: d.shortComment, type: 2 },
                    { text: d.unitName, type: 2 },
                    this.mapNumber(missing),
                    this.mapNumber(corrected),
                ];
            })
            .sortBy(d => (d[4] as any).value)
            .reverse()
            .value();
        return rows;
    }

    private mapNumber(value: number) {
        return {
            text: value
                ? (value > 0 && value < 0.5 / 100) ? '>0%' : this._format(value)
                : '',
            classed: {
                'danger-cell': value >= .2,
                'alert alert-warning': value >= .05 && value < 0.2,
                'right-col': true
            },
            value: value,
            type: 2
        };
    }

    getIdentifiers(selectedGroup: GroupNameDto, viewModels: IValueViewModel[], includeChildren: boolean): IValueViewModel[] {
        let identifiers: IValueViewModel[];
        if (selectedGroup) {
            const absoluteName = selectedGroup.absoluteName;
            if (includeChildren) {
                identifiers = viewModels.filter(d => d.groupAbsolutePath.indexOf(absoluteName) >= 0);
            } else {
                identifiers = viewModels.filter(d => d.groupAbsolutePath === absoluteName);
            }
        } else {
            identifiers = viewModels.map(d => d);
        }
        return identifiers;
    }
}